import React from 'react';
import { formatFieldName, formatValue, getBadgeColor } from '../../utils/formatters';

const SEOSection = ({ seoAnswers }) => {
    if (seoAnswers.length === 0) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>SEO</h4>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '15px'
            }}>
                {seoAnswers.map(([field, value]) => {
                    const isSeoKeyFindings = field === 'seo_key_findings';
                    return (
                        <div
                            key={field}
                            style={{
                                backgroundColor: '#2d2d2d',
                                border: '1px solid #404040',
                                borderRadius: '6px',
                                padding: isSeoKeyFindings ? '20px' : '15px',
                                gridColumn: isSeoKeyFindings ? '1 / -1' : undefined
                            }}
                        >
                            {isSeoKeyFindings ? (
                                <>
                                    <h4 style={{
                                        margin: '0 0 12px 0',
                                        color: '#e0e0e0',
                                        fontWeight: '600'
                                    }}>
                                        {formatFieldName(field)}
                                    </h4>
                                    <p style={{
                                        margin: 0,
                                        color: '#d0d0d0',
                                        lineHeight: '1.6',
                                        fontSize: '14px'
                                    }}>
                                        {value}
                                    </p>
                                </>
                            ) : (
                                <>
                                    <div style={{
                                        fontSize: '12px',
                                        color: '#a0a0a0',
                                        textTransform: 'uppercase',
                                        marginBottom: '8px',
                                        fontWeight: '600',
                                        letterSpacing: '0.5px'
                                    }}>
                                        {formatFieldName(field)}
                                    </div>
                                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                        <span style={{
                                            display: 'inline-block',
                                            backgroundColor: getBadgeColor(field, value),
                                            color: '#fff',
                                            padding: '4px 12px',
                                            borderRadius: '12px',
                                            fontSize: '14px'
                                        }}>
                                            {formatValue(value)}
                                        </span>
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SEOSection;






